import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { logUsage } from 'owa-analytics';
import {
    MailTipsActionType,
    MailTipsType,
    MailTipsCategory,
    MailtipsActionDatapointName,
} from '../datapoints';

export default function removeRecipientsAndLogMailTipsDatapoint(
    onRemove: (recipient: EmailAddressWrapper[]) => void,
    recipients: EmailAddressWrapper[],
    mailTipsCategory?: MailTipsCategory,
    mailTipsType?: MailTipsType,
    recipientCount?: number
) {
    onRemove(recipients);
    // Log datapoint
    logUsage(MailtipsActionDatapointName, [
        MailTipsActionType.RemoveRecipient,
        mailTipsCategory,
        mailTipsType,
        recipientCount,
    ]);
}
